import { HttpContextToken } from '@angular/common/http';
import { BackendApiType } from '@app/shared/types/enums/backend-api-type.enum';

export const BACKEND_API_TYPE_TOKEN = new HttpContextToken<BackendApiType>(
  () => null,
);
